import { useContext } from 'react';
import { scanSynchronizerContext } from '.';

/**
 * Save Data Synchronizer Hook
 */
export const useScanSynchronizer = () => {
  const context = useContext(scanSynchronizerContext);
  if (!context) {
    throw new Error('useScanSynchronizer must be used within a ScanSynchronizerProvider');
  }
  return context;
};
